import { useEffect, useRef } from 'react';
import styles from './ScreenReaderAnnouncements.module.css';

export function ScreenReaderAnnouncements({ announcement }) {
  const liveRegionRef = useRef(null);

  useEffect(() => {
    if (!liveRegionRef.current) {
      return;
    }

    liveRegionRef.current.textContent = announcement || '';
  }, [announcement]);

  return (
    <>
      <div
        ref={liveRegionRef}
        role="status"
        aria-live="polite"
        aria-atomic="true"
        className={styles.srOnly}
      />

      <div className={styles.srOnly}>
        <h2>Keyboard Navigation</h2>
        <ul>
          <li>Use arrow keys to navigate between cells</li>
          <li>Press Enter to edit a grade</li>
          <li>
            Press Space or Enter on category headers to expand or collapse
          </li>
          <li>Press Tab to move forward, Shift+Tab to move backward</li>
          <li>Press Home to go to the first cell in a row</li>
          <li>Press End to go to the last cell in a row</li>
          <li>Press Ctrl+Home to go to the first cell in the table</li>
          <li>Press Ctrl+End to go to the last cell in the table</li>
        </ul>
      </div>
    </>
  );
}
